module.exports = __webpack_public_path__ + "img/img-promo01.2fb0b386.png";